import React, { useState, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";

import { Image_URL, privateRequest } from "../../commonApi/CommonApi";
import { Editor } from "@tinymce/tinymce-react";
import ReactQuill from "react-quill";
const options = [
  { value: "apple", label: "Apple" },
  { value: "banana", label: "Banana" },
  { value: "orange", label: "Orange" },
];
function EditPackage() {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const [additionalServices, setAdditionalServices] = useState([]);

  if (!Array.isArray(additionalServices) || additionalServices.length === 0) {
    console.error("Additional services data is invalid or empty.");
  }

  const initialSelectedServices =
    additionalServices?.map((item) => ({
      service: item?.service || "defaultServiceId",

      variant: "",
    })) || [];

  useEffect(() => {
    if (additionalServices && additionalServices.length > 0) {
      console.log('Setting selectedServices from additionalServices:', additionalServices);
      setSelectedServices(additionalServices);
    }
  }, [additionalServices]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editorData, setEditorData] = useState(state?.discription);
  const [combineData, setCombineData] = useState([]);
  const [Name, setName] = useState(state?.packageTitle);
  const [packageType, setPackageType] = useState(state?.packageType);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [ServiceStatus, setServiceStatus] = useState(
    state?.Status == true ? 1 : 0
  );
  const [selectedParentCategory, setSelectedParentCategory] = useState({});
  const [additionalAddOnServices, setAdditionalAddOnServices] = useState([]);
  const [selectedChildCategories, setSelectedChildCategories] = useState([]);
  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState();
  // const [additionalServices, setAdditionalServices] = useState([]);
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [selectedServiceGroups, setSelectedServiceGroups] = useState(
    state?.ServiceGroups.map((group) => ({
      value: group._id,
      label: group.GroupName,
    })) || []
  );

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [discription, setDiscription] = useState();
  const [regularPrice, setRegularPrice] = useState(state?.RPrice);
  const [salePrice, setSalePrice] = useState(state?.SPrice);
  const [pricesCalculated, setPricesCalculated] = useState(false);
  const [payableAmount, setPayableAmount] = useState(state?.payble);
  const [discount, setDiscount] = useState(state?.discount);
  const [discounts, setDiscounts] = useState([]);
  const [isDiscription, setisDiscription] = useState(
    state?.IsDiscription || false
  );

  const navigate = useNavigate();
  // Check for data in sessionStorage as fallback if state is not available
  const [item, setItem] = useState(state);
  const [packageIdFromUrl, setPackageIdFromUrl] = useState(null);
  console.log('EditPackage - state data:', state);

  // Capture package ID from URL parameters
  useEffect(() => {
    const urlPackageId = searchParams.get('packageId');
    if (urlPackageId) {
      setPackageIdFromUrl(urlPackageId);
      console.log('EditPackage - Package ID from URL:', urlPackageId);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!item) {
      try {
        // Try sessionStorage first
        let storedData = sessionStorage.getItem('packageEditData');
        console.log('EditPackage - stored data from sessionStorage:', storedData);

        // If not in sessionStorage, try localStorage
        if (!storedData) {
          storedData = localStorage.getItem('packageEditData');
          console.log('EditPackage - stored data from localStorage:', storedData);
        }

        if (storedData) {
          const parsedItem = JSON.parse(storedData);
          console.log('EditPackage - parsed item data from storage:', {
            parsedItem: parsedItem,
            hasRequiredFields: {
              packageTitle: !!parsedItem.packageTitle,
              PcatId: !!parsedItem.PcatId,
              ChildId: !!parsedItem.ChildId,
              ServiceGroups: !!parsedItem.ServiceGroups,
              serviceId: !!parsedItem.serviceId,
              Status: parsedItem.Status !== undefined
            }
          });
          setItem(parsedItem);

          // Initialize form fields from stored data
          if (parsedItem.packageTitle) setName(parsedItem.packageTitle);
          if (parsedItem.packageType) setPackageType(parsedItem.packageType);
          if (parsedItem.Status !== undefined) setServiceStatus(parsedItem.Status == true ? 1 : 0);
          // Prices will be handled by the dedicated price calculation useEffects
          console.log('Storage data useEffect - prices will be handled by price calculation useEffects');
          if (parsedItem.payble) setPayableAmount(parsedItem.payble);
          if (parsedItem.discount) setDiscount(parsedItem.discount);
          if (parsedItem.discription) setDiscription(parsedItem.discription);
          if (parsedItem.IsDiscription !== undefined) setisDiscription(parsedItem.IsDiscription);
          if (parsedItem.PCgroup) setSelectedGroup(parsedItem.PCgroup);

          console.log('EditPackage - initialized form fields from storage data');
        }
      } catch (error) {
        console.error('Error parsing package data from storage:', error);
      }
    }
  }, [item]);

  // If still no item data, check URL parameters and fetch package data
  const [isLoadingFromId, setIsLoadingFromId] = useState(false);

  // Handle cases where package ID is in URL but no data is available
  useEffect(() => {
    const packageId = searchParams.get('packageId');
    // Only show error if we have no item data AND combineData has loaded AND we're not already loading
    if (!item && packageId && !isLoadingFromId && combineData && Object.keys(combineData).length > 0) {
      console.log('EditPackage - checking for missing data with packageId:', packageId);

      // Try to find package in combineData as a last resort
      if (combineData.Package && combineData.Package.length > 0) {
        const foundPackage = combineData.Package.find(pkg => pkg._id === packageId);
        if (foundPackage) {
          console.log('EditPackage - found package in combineData as fallback:', foundPackage);
          setItem(foundPackage);
          return;
        }
      }

      // Only show error after a reasonable delay to allow for data loading
      setTimeout(() => {
        if (!item) {
          console.log('EditPackage - still no package data after delay, showing error');
          Swal.fire({
            icon: 'warning',
            title: 'Package Data Not Found',
            text: 'Please try opening the package edit form again from the service edit page.',
            confirmButtonText: 'OK'
          });
        }
      }, 3000); // Wait 3 seconds before showing error
    }
  }, [searchParams, item, isLoadingFromId, combineData]);

  // Helper functions for price calculations
  const calculateTotalPrices = (services, addons = []) => {
    let totalRegular = 0;
    let totalSale = 0;

    // Calculate from main services
    services.forEach((service) => {
      if (service?.regularPrice !== undefined || service?.salePrice !== undefined) {
        const serviceRegular = parseFloat(service.regularPrice || 0);
        const serviceSale = parseFloat(service.salePrice || 0);

        totalRegular += serviceRegular;
        totalSale += serviceSale;
      }
    });

    // Calculate from addon services
    addons.forEach((addon) => {
      if (addon?.regularPrice !== undefined || addon?.salePrice !== undefined) {
        const addonRegular = parseFloat(addon.regularPrice || 0);
        const addonSale = parseFloat(addon.salePrice || 0);

        totalRegular += addonRegular;
        totalSale += addonSale;
      }
    });

    return { totalRegular, totalSale };
  };

  const updatePrices = (regular, sale) => {
    setRegularPrice(regular);
    setSalePrice(sale);
    setPricesCalculated(true);
  };

  const logPriceCalculation = (context, data) => {
    console.log(`Price calculation - ${context}:`, data);
  };

  // 1. Initial price calculation from item data (database or calculated)
  useEffect(() => {
    logPriceCalculation('initialization triggered', {
      hasItem: !!item,
      hasServiceId: !!(item?.serviceId),
      serviceIdLength: item?.serviceId?.length,
      hasCombineData: !!combineData?.newServiceId,
      currentRegularPrice: regularPrice,
      currentSalePrice: salePrice,
      pricesCalculated,
      dbRPrice: item?.RPrice,
      dbSPrice: item?.SPrice
    });

    if (item && !pricesCalculated && combineData?.newServiceId) {
      // Use database prices if they exist
      if (item.RPrice && item.SPrice) {
        logPriceCalculation('using database prices', {
          dbRPrice: item.RPrice,
          dbSPrice: item.SPrice
        });
        updatePrices(parseFloat(item.RPrice), parseFloat(item.SPrice));
        return; // Exit early - we're done
      }

      // No database prices, so we'll let the selectedServices useEffect handle it
      logPriceCalculation('no database prices found, will calculate from selectedServices');
    }
  }, [item, combineData?.newServiceId, pricesCalculated]);

  // 2. Calculate prices from selectedServices/selectedAddons after they're loaded
  useEffect(() => {
    logPriceCalculation('selectedServices triggered', {
      selectedServicesLength: selectedServices.length,
      selectedAddonsLength: selectedAddons.length,
      pricesCalculated,
      firstServiceHasPrices: selectedServices[0]?.regularPrice || selectedServices[0]?.salePrice
    });

    // Only calculate if we have services and prices haven't been calculated yet
    if (selectedServices.length > 0 && (!pricesCalculated || (regularPrice === 0 && salePrice === 0))) {
      const hasPriceData = selectedServices.some(s => s.regularPrice || s.salePrice);

      if (hasPriceData) {
        logPriceCalculation('calculating from selectedServices', selectedServices);

        const { totalRegular, totalSale } = calculateTotalPrices(selectedServices, selectedAddons);

        if (totalRegular > 0 || totalSale > 0) {
          logPriceCalculation('final calculated prices', {
            totalRegular,
            totalSale,
            fromServices: selectedServices.length,
            fromAddons: selectedAddons.length
          });

          updatePrices(totalRegular, totalSale);
        }
      }
    }
  }, [selectedServices, selectedAddons]);

  // Debug logging (can be removed in production)
  if (process.env.NODE_ENV === 'development') {
    console.log('EditPackage - current state values:', {
      Name,
      packageType,
      ServiceStatus,
      selectedParentCategory,
      selectedChildCategories,
      selectedServiceGroups,
      additionalServices,
      regularPrice,
      salePrice,
      imagePreview,
      selectedFile
    });
  }

  // Helper function to get all services and their status in structured format
  const getAllServicesWithStatus = (packageData) => {
    if (!packageData || !packageData.serviceId || !Array.isArray(packageData.serviceId)) {
      return [];
    }

    return packageData.serviceId.map((serviceItem, index) => {
      const service = serviceItem?.service;

      if (!service) return null;

      return {
        serviceIndex: index,
        serviceId: service._id,
        serviceName: service.ServiceName,
        serviceStatus: service.ServiceStatus,
        selectedVariantId: serviceItem.variant,
        variants: service.ServiceVarients?.map((variant, variantIndex) => {
          const variantDesc = variant.VarientDiscription?.[0] || {};
          return {
            variantIndex: variantIndex,
            variantId: variant._id,
            variantType: variant.ServiceType?.Name,
            variantStatus: variantDesc.ServiceStatus,
            regularPrice: variantDesc.regularPrice,
            salePrice: variantDesc.salePrice,
            isSelected: variant._id === serviceItem.variant
          };
        }) || []
      };
    }).filter(Boolean);
  };

  // Console log all services and their status
  useEffect(() => {
    if (item && item.serviceId && Array.isArray(item.serviceId)) {
      console.log('=== PACKAGE SERVICES AND STATUS ===');
      console.log('Package Name:', item.packageTitle);
      console.log('Total Services:', item.serviceId.length);
      console.log('-----------------------------------');

      item.serviceId.forEach((serviceItem, index) => {
        const service = serviceItem?.service;

        if (service) {
          console.log(`\n[Service ${index + 1}]`);
          console.log('Service ID:', service._id);
          console.log('Service Name:', service.ServiceName);
          console.log('Service Status:', service.ServiceStatus);

          // Check if ServiceVarients exists and iterate through them
          if (service.ServiceVarients && Array.isArray(service.ServiceVarients)) {
            console.log('Total Variants:', service.ServiceVarients.length);

            service.ServiceVarients.forEach((variant, variantIndex) => {
              console.log(`\n  [Variant ${variantIndex + 1}]`);
              console.log('  Variant ID:', variant._id);
              console.log('  Variant Type:', variant.ServiceType?.Name);

              // Check if VarientDiscription exists
              if (variant.VarientDiscription && Array.isArray(variant.VarientDiscription) && variant.VarientDiscription.length > 0) {
                const variantDesc = variant.VarientDiscription[0];
                console.log('  Variant Status:', variantDesc.ServiceStatus);
                console.log('  Regular Price:', variantDesc.regularPrice);
                console.log('  Sale Price:', variantDesc.salePrice);
              }
            });
          }

          // Log the selected variant for this service in the package
          console.log('\nSelected Variant ID for this service:', serviceItem.variant);
        }
        console.log('-----------------------------------');
      });

      console.log('\n=== END OF SERVICES ===\n');

      // Get structured data
      const servicesData = getAllServicesWithStatus(item);
      console.log('Structured Services Data:', servicesData);

      // Example: Get only active services
      const activeServices = servicesData.filter(service => service.serviceStatus === true || service.serviceStatus === 'Active');
      console.log('Active Services:', activeServices);

      // Example: Get inactive variant statuses
      servicesData.forEach(service => {
        const inactiveVariants = service.variants.filter(v => v.variantStatus === false || v.variantStatus === 'Inactive');
        if (inactiveVariants.length > 0) {
          console.log(`Service "${service.serviceName}" has ${inactiveVariants.length} inactive variant(s):`, inactiveVariants);
        }
      });
    }
  }, [item]);

  // Debug mode - set to false for production
  const DEBUG_MODE = false;

  // Debug component to show loaded data (only in debug mode)
  const DebugDataDisplay = () => DEBUG_MODE ? (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'white',
      border: '2px solid red',
      padding: '10px',
      maxWidth: '300px',
      fontSize: '12px',
      zIndex: 9999,
      maxHeight: '400px',
      overflow: 'auto'
    }}>
      <h4>Debug Data</h4>
      <p><strong>Item:</strong> {item ? 'Loaded' : 'Not loaded'}</p>
      <p><strong>Package Name:</strong> {Name || 'Not set'}</p>
      <p><strong>Parent Category:</strong> {selectedParentCategory?.label || 'Not set'}</p>
      <p><strong>Child Categories:</strong> {Array.isArray(selectedChildCategories) ? selectedChildCategories.length : 'Not set'}</p>
      <p><strong>Service Groups:</strong> {Array.isArray(selectedServiceGroups) ? selectedServiceGroups.length : 'Not set'}</p>
      <p><strong>CombineData Keys:</strong> {combineData ? Object.keys(combineData).join(', ') : 'Not loaded'}</p>
      {item && (
        <div>
          <p><strong>Raw Item Data:</strong></p>
          <pre style={{ fontSize: '10px', maxHeight: '150px', overflow: 'auto' }}>
            {JSON.stringify(item, null, 2)}
          </pre>
        </div>
      )}
    </div>
  ) : null;

  // Initialize state from storage data if available (for new tab navigation)
  useEffect(() => {
    if (item && !state) {
      // This means data came from storage, not from navigation state
      console.log('EditPackage - initializing from storage data:', item);

      // Update basic state variables that depend on item data
      setName(item.packageTitle || "");
      setPackageType(item.packageType || "");
      setServiceStatus(item.Status === true ? "1" : "0");
      setDiscription(item.discription || "");
      setEditorData(item.discription || "");
      // Prices will be handled by the dedicated price calculation useEffects
      console.log('Item initialization useEffect - prices will be handled by price calculation useEffects');
      setPayableAmount(item.payble || "");
      setDiscount(item.discount || "");
      setisDiscription(item.IsDiscription || false);

      // Set image data
      setSelectedFile(item.packageImage || item.CoverImage || null);
      const imageUrl = item.packageImage ? Image_URL + item.packageImage : "";
      console.log('EditPackage - setting image preview:', {
        packageImage: item.packageImage,
        imageUrl: imageUrl,
        Image_URL: Image_URL
      });
      setImagePreview(imageUrl);

      // Clean up storage after successful initialization (longer timeout to ensure full processing)
      setTimeout(() => {
        try {
          sessionStorage.removeItem('packageEditData');
          localStorage.removeItem('packageEditData');
          console.log('EditPackage - cleaned up storage data');
        } catch (error) {
          console.error('Error cleaning up storage:', error);
        }
      }, 10000); // Longer timeout to allow complete data processing
    }
  }, [item, state]);

  // Comprehensive data processing when combineData is available
  useEffect(() => {
    if (combineData && item && Object.keys(combineData).length > 0) {
      console.log('EditPackage - processing item data with combineData:', {
        item: item,
        itemSource: item.source || 'unknown',
        isFromState: !!state,
        combineDataKeys: Object.keys(combineData),
        hasParentCategories: !!combineData.parentCategories,
        parentCategoriesCount: combineData.parentCategories?.length,
        hasServiceGroups: !!combineData.serviceGroups,
        itemPcatId: item.PcatId,
        itemChildId: item.ChildId,
        itemServiceGroups: item.ServiceGroups
      });

      // Handle Parent Category
      if (item.PcatId) {
        console.log('EditPackage - processing parent category:', {
          itemPcatId: item.PcatId,
          availableCategories: combineData.parentCategories?.map(cat => ({ id: cat._id, name: cat.PCName }))
        });

        const parentCategory = combineData.parentCategories?.find(
          (category) => category._id === (item.PcatId?._id || item.PcatId)
        );
        if (parentCategory) {
          const selectedParentCategory = {
            value: parentCategory._id,
            label: parentCategory.PCName,
          };
          setSelectedParentCategory(selectedParentCategory);
          console.log('EditPackage - set parent category:', selectedParentCategory);
        } else {
          console.log('EditPackage - parent category not found for PcatId:', item.PcatId, 'Available:', combineData.parentCategories?.length);
          // Try to find by matching name or other properties as fallback
          if (typeof item.PcatId === 'string') {
            const fallbackCategory = combineData.parentCategories?.find(
              (category) => category.PCName?.toLowerCase().includes(item.PcatId.toLowerCase())
            );
            if (fallbackCategory) {
              const selectedParentCategory = {
                value: fallbackCategory._id,
                label: fallbackCategory.PCName,
              };
              setSelectedParentCategory(selectedParentCategory);
              console.log('EditPackage - set parent category via fallback:', selectedParentCategory);
            }
          }
        }
      }

      // Handle Child Categories
      if (item.ChildId && Array.isArray(item.ChildId)) {
        console.log('EditPackage - processing child categories:', {
          itemChildId: item.ChildId,
          availableChildCategories: combineData.childCategories?.length
        });

        const selectedChildCategories = item.ChildId.map((child) => ({
          label: child.CCName || child.label || "",
          value: child._id || child.value || child,
        }));
        handleChildCategoryChange(selectedChildCategories);
        console.log('EditPackage - set child categories:', selectedChildCategories);
      } else if (item.ChildId && !Array.isArray(item.ChildId)) {
        // Handle single child category
        console.log('EditPackage - processing single child category:', item.ChildId);
        const childCategory = [{
          label: item.ChildId.CCName || item.ChildId.label || "",
          value: item.ChildId._id || item.ChildId.value || item.ChildId,
        }];
        handleChildCategoryChange(childCategory);
        console.log('EditPackage - set single child category:', childCategory);
      }

      // Handle Service Groups
      if (item.ServiceGroups && Array.isArray(item.ServiceGroups)) {
        console.log('EditPackage - processing service groups:', {
          itemServiceGroups: item.ServiceGroups,
          availableServiceGroups: combineData.serviceGroups?.length
        });

        const serviceGroups = item.ServiceGroups.map((group) => ({
          value: group._id || group.value,
          label: group.GroupName || group.label,
        }));
        setSelectedServiceGroups(serviceGroups);
        console.log('EditPackage - set service groups:', serviceGroups);
      } else {
        console.log('EditPackage - no service groups found in item data:', item.ServiceGroups);
      }

      // Handle Services
      if (item.serviceId && Array.isArray(item.serviceId)) {
        const servicesnormal = item.serviceId.map((serviceItem) => {
          const serviceId = serviceItem?.service?._id || serviceItem?.service;
          const variantId = serviceItem?.variant;

          // Find service and variant to get prices
          const service = combineData.newServiceId?.find(s => s._id === serviceId);
          let regularPrice = 0;
          let salePrice = 0;

          if (service && variantId) {
            const variant = service.ServiceVarients?.find(v => v._id === variantId);
            if (variant && variant.VarientDiscription && variant.VarientDiscription[0]) {
              regularPrice = parseFloat(variant.VarientDiscription[0].regularPrice || 0);
              salePrice = parseFloat(variant.VarientDiscription[0].salePrice || 0);
            }
          }

          return {
            service: serviceId,
            variant: variantId,
            regularPrice: regularPrice,
            salePrice: salePrice,
            id: variantId
          };
        });

        console.log('EditPackage - set services with prices:', servicesnormal);
        setAdditionalServices(servicesnormal);
      }

      // Handle Addon Services
      if (item.AddonService && Array.isArray(item.AddonService)) {
        const servicesaddons = item.AddonService.map((serviceItem) => {
          const serviceId = serviceItem?.service?._id || serviceItem?.service;
          const variantId = serviceItem?.variant;

          // Find service and variant to get prices
          const service = combineData.newServiceId?.find(s => s._id === serviceId);
          let regularPrice = 0;
          let salePrice = 0;

          if (service && variantId) {
            const variant = service.ServiceVarients?.find(v => v._id === variantId);
            if (variant && variant.VarientDiscription && variant.VarientDiscription[0]) {
              regularPrice = parseFloat(variant.VarientDiscription[0].regularPrice || 0);
              salePrice = parseFloat(variant.VarientDiscription[0].salePrice || 0);
            }
          }

          return {
            service: serviceId,
            variant: variantId,
            regularPrice: regularPrice,
            salePrice: salePrice,
            id: variantId
          };
        });
        setAdditionalAddOnServices(servicesaddons);
        console.log('EditPackage - set addon services with prices:', servicesaddons);
      }

      // Handle Parent Group for Services
      if (item.PCgroup) {
        setSelectedGroup(item.PCgroup);
        getAllServices(item.PCgroup);
        console.log('EditPackage - set parent group:', item.PCgroup);
      } else if (combineData.ParentGroup && combineData.ParentGroup.length > 0) {
        const id = combineData.ParentGroup[0]._id;
        setSelectedGroup(id);
        getAllServices(id);
        console.log('EditPackage - set default parent group:', id);
      }

      // Additional processing for packages coming from storage
      setSelectedFile(item ? (item.CoverImage || item.packageImage) : null);
      setServiceStatus(item ? (item.Status ? "1" : "0") : "0");
      const imageUrl2 = item && item.packageImage ? Image_URL + item.packageImage : "";
      console.log('EditPackage - setting image preview (second location):', {
        packageImage: item?.packageImage,
        imageUrl: imageUrl2,
        Image_URL: Image_URL
      });
      setImagePreview(imageUrl2);

      setDiscription(item?.discription || "");

      console.log('EditPackage - completed comprehensive data processing');
    }
  }, [item, combineData]);

  useEffect(() => {
    if (additionalAddOnServices.length > 0) {
      setSelectedAddons(additionalAddOnServices);
    }
  }, [additionalAddOnServices]);
  console.log("selectedAddons", selectedAddons);


  useEffect(() => {
    if (combineData.length > 0) {
      let id = combineData?.ParentGroup[0]?._id;
      setSelectedGroup(id);
      getAllServices(id);
    }
  }, [combineData]);

  useEffect(() => {
    if (!selectedServices || selectedServices.length === 0) return;

    const updatedSelectedServices = selectedServices?.map((item) => {
      let variantPrice = getVariantsForService(item?.service).find(
        (id) => id?._id == item?.variant
      );
      let regularPrice = variantPrice?.VarientDiscription[0]?.regularPrice;
      let salePrice = variantPrice?.VarientDiscription[0]?.salePrice;

      // Merge the new properties with the existing ones
      return {
        ...item, // Keep existing properties
        regularPrice: regularPrice,
        salePrice: salePrice,
        id: item?.variant,
      };
    });
    console.log("additional vala useeffect");
    setSelectedServices((prevSelectedServices) => {
      return prevSelectedServices.map((prevItem, index) => {
        return {
          ...prevItem,
          ...updatedSelectedServices[index], // Merge new properties with existing ones
        };
      });
    });
  }, [additionalServices]);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get("Service/CombineApis");
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getPackageDiscountData = async (e) => {
    try {
      const response = await privateRequest.get("PackageDiscount"); // + pc group Id lagani hai
      // setServiceOptions(response?.data.services);
      console.log("discount slab", response);
      setDiscounts(response.data.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  useEffect(() => {
    getPackageDiscountData();
  }, []);

  console.log("selectedChildCategories", selectedChildCategories);
  selectedChildCategories.forEach((categoryId) => {
    console.log("categoryId", categoryId);
  });
  console.log("selectedServiceGroups", selectedServiceGroups);
  console.log("selectedServiceGroups", selectedChildCategories);

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    console.log('EditPackage - file input changed:', file);
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        console.log('EditPackage - file reader result:', reader.result);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // No file selected, keep existing preview if any
      console.log('EditPackage - no file selected, keeping existing preview');
    }
  };

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
  };

  const handleChildCategoryChange = (selectedOptions) => {
    const selectedIds = selectedOptions.map((option) => option.value);
    setSelectedChildCategories(selectedIds);
  };

  useEffect(() => {
    getAllDocumentData();
  }, []);

  useEffect(() => {
    const childCategorySelectOptions = combineData?.childCategories
      ?.filter(
        (category) => category.PCName[0] === selectedParentCategory?.value
      )
      ?.map((category) => ({
        value: category._id,
        label: category.CCName,
      }));
    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.childCategories]);

  useEffect(() => {
    const serviceGroupSelectOptions = combineData?.serviceGroups
      ?.filter((group) => group.PCName[0] === selectedParentCategory.value)
      ?.map((group) => ({
        value: group._id,
        label: group.GroupName,
      }));

    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  const getAllServices = async (e) => {
    try {
      const response = await privateRequest.get(
        "Service/AllServicebyPGroup/" + e
      ); // + pc group Id lagani hai
      setServiceOptions(response?.data.services);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const handleGroupChange = (e) => {
    const selectedGroupId = e.target.value;
    setSelectedGroup(selectedGroupId);
    getAllServices(selectedGroupId);
  };

  const handleServiceChange = (index, selectedServiceId) => {
    const updatedServices = [...selectedServices];
    const selectedService = combineData?.newServiceId?.find(
      (service) => service._id == selectedServiceId
    );

    // Get default prices from first variant
    const defaultVariant = selectedService?.ServiceVarients?.[0]?.VarientDiscription?.[0];
    const regularPrice = parseFloat(defaultVariant?.regularPrice || 0);
    const salePrice = parseFloat(defaultVariant?.salePrice || 0);

    updatedServices[index] = {
      ...updatedServices[index],
      service: selectedServiceId,
      variant: null,
      regularPrice,
      salePrice,
    };

    setSelectedServices(updatedServices);

    // Recalculate total prices
    const { totalRegular, totalSale } = calculateTotalPrices(updatedServices, selectedAddons);

    logPriceCalculation('service changed', {
      serviceIndex: index,
      selectedServiceId,
      regularPrice,
      salePrice,
      totalRegular,
      totalSale
    });

    updatePrices(totalRegular, totalSale);
  };

  const handleVariantChange = (index, selectedVariantId) => {
    const updatedServices = [...selectedServices];
    updatedServices[index] = {
      ...updatedServices[index],
      variant: selectedVariantId?.id,
      regularPrice: selectedVariantId?.regularPrice,
      salePrice: selectedVariantId?.salePrice,
      id: selectedVariantId?.id,
    };
    setSelectedServices(updatedServices);

    // Recalculate total prices after variant change
    const { totalRegular, totalSale } = calculateTotalPrices(updatedServices, selectedAddons);

    logPriceCalculation('variant changed', {
      serviceIndex: index,
      selectedVariant: selectedVariantId,
      regularPrice: selectedVariantId?.regularPrice,
      salePrice: selectedVariantId?.salePrice,
      totalRegular,
      totalSale
    });

    updatePrices(totalRegular, totalSale);
  };

  const getVariantsForService = (serviceId) => {
    // 1. Try serviceOptions (filtered by group)
    let selectedService = serviceOptions?.find(
      (option) => option?._id === serviceId
    );

    // 2. Try combineData (global list)
    if (!selectedService) {
      selectedService = combineData?.newServiceId?.find(
        (service) => service._id === serviceId
      );
    }

    // 3. Try populated item data (services)
    if (!selectedService && item?.serviceId) {
      const sItem = item.serviceId.find(
        (s) => (s.service?._id || s.service) === serviceId
      );
      if (sItem?.service && typeof sItem.service === "object") {
        selectedService = sItem.service;
      }
    }

    // 4. Try populated item data (addons)
    if (!selectedService && item?.AddonService) {
      const sItem = item.AddonService.find(
        (s) => (s.service?._id || s.service) === serviceId
      );
      if (sItem?.service && typeof sItem.service === "object") {
        selectedService = sItem.service;
      }
    }

    return selectedService ? selectedService.ServiceVarients : [];
  };

  const handleAddService = () => {
    setSelectedServices([...selectedServices, {}]);
  };

  const handleAddAddonService = () => {
    setSelectedAddons([...selectedAddons, {}]);
  };

  const handleRemoveService = (id) => {
    const index = selectedServices?.findIndex(
      (service) => service?.variant == id
    );

    console.log("index of service", index);

    if (index != -1) {
      console.log("index andar", index);

      const updatedSelectedaServices = [...selectedServices];

      updatedSelectedaServices.splice(index, 1);

      console.log("updatedSelectedaServices", updatedSelectedaServices);

      setSelectedServices(updatedSelectedaServices);
    } else {
      console.error("Service with ID", index, "not found.");
    }
  };

  const handleRemoveAdonService = (id) => {
    const index = selectedAddons.findIndex((service) => service.variant === id);

    if (index != -1) {
      const updatedSelectedServices = [...selectedAddons];
      updatedSelectedServices.splice(index, 1);
      setSelectedAddons(updatedSelectedServices);
    } else {
      console.error("Service with ID", id, "not found.");
    }
  };
  const handleVariantAddOnChange = (index, selectedVariantId) => {
    const updatedAddons = [...selectedAddons];

    // Find the service and variant to get prices
    const service = combineData?.newServiceId?.find(s => s._id === updatedAddons[index]?.service);
    let regularPrice = 0;
    let salePrice = 0;

    if (service && selectedVariantId) {
      const variant = service.ServiceVarients?.find(v => v._id === selectedVariantId);
      if (variant && variant.VarientDiscription && variant.VarientDiscription[0]) {
        regularPrice = parseFloat(variant.VarientDiscription[0].regularPrice || 0);
        salePrice = parseFloat(variant.VarientDiscription[0].salePrice || 0);
      }
    }

    updatedAddons[index] = {
      ...updatedAddons[index],
      variant: selectedVariantId,
      regularPrice,
      salePrice,
    };
    setSelectedAddons(updatedAddons);

    // Recalculate total prices after addon variant change
    const { totalRegular, totalSale } = calculateTotalPrices(selectedServices, updatedAddons);

    logPriceCalculation('addon variant changed', {
      addonIndex: index,
      selectedVariant: selectedVariantId,
      regularPrice,
      salePrice,
      totalRegular,
      totalSale
    });

    updatePrices(totalRegular, totalSale);
  };

  // const handleAddAddonService = () => {
  //   setAdditionalAddOnServices([...additionalAddOnServices, {}]);
  //   setSelectedAddons([...selectedAddons, {}]);
  // };

  // const handleRemoveAdonService = (index) => {
  //   const updatedAdditionalServices = [...additionalAddOnServices];
  //   updatedAdditionalServices.splice(index, 1);
  //   setAdditionalAddOnServices(updatedAdditionalServices);

  //   const updatedSelectedServices = [...selectedAddons];
  //   updatedSelectedServices.splice(index, 1);
  //   setSelectedAddons(updatedSelectedServices);
  // };

  const handleAddOnServiceChange = (index, selectedServiceId) => {
    const updatedServices = [...selectedAddons];
    updatedServices[index] = {
      ...updatedServices[index],
      service: selectedServiceId,
      variant: null,
    };
    setSelectedAddons(updatedServices);
  };

  // Use state values instead of calculating in component body
  const totalRegularPrice = regularPrice;
  const totalSalePrice = salePrice;

  // Debug logging for UI values
  console.log('UI State Values:', {
    regularPrice,
    salePrice,
    totalRegularPrice,
    totalSalePrice,
    selectedServices: selectedServices.map(s => ({
      service: s.service,
      variant: s.variant,
      regularPrice: s.regularPrice,
      salePrice: s.salePrice
    }))
  });

  const getDiscountPercentage = (totalSalePrice, discounts) => {
    let applicableDiscount = 0;
    for (const discount of discounts) {
      if (salePrice >= discount.MinValue) {
        applicableDiscount = parseInt(discount.DiscountApplied, 10);
      }
    }
    return applicableDiscount;
  };

  // Sort discounts by MinValue in ascending order
  discounts.length > 0 && discounts?.sort((a, b) => a.MinValue - b.MinValue);
  const discountPercentagee =
    getDiscountPercentage(totalSalePrice, discounts || []) || 0;

  const discountAmount = Math.round(
    (totalRegularPrice * discountPercentagee) / 100
  );

  console.log("discountPercentagee", discountPercentagee);
  console.log("discountAmount", discountAmount);

  const calculateDiscountedPrice = () => {
    const discountPercentage = parseInt(discountPercentagee || "0", 10);
    const discountAmount = Math.round(
      (totalSalePrice * discountPercentage) / 100
    );
    return {
      discountAmount,
      discountedPrice: totalSalePrice - discountAmount,
    };
  };

  let { discountedPrice } = calculateDiscountedPrice(
    totalSalePrice,
    discountAmount
  );

  let totalSavedPrice = discountedPrice;

  console.log(
    "totalSavedPrice",
    packageType == "Editable" ? totalSavedPrice : payableAmount
  );
  // Function to get the next discount based on totalSalePrice
  const getNextDiscount = (totalSalePrice, discounts) => {
    for (const discount of discounts) {
      if (totalSalePrice < discount.MinValue) {
        return discount;
      }
    }
    return null;
  };

  // Get the next discount
  const nextDiscount = getNextDiscount(totalSalePrice, discounts);
  const moreServiceValueForDiscount = nextDiscount
    ? nextDiscount.MinValue - totalSalePrice
    : 0;

  // Function to get the discount based on totalSavedPrice
  const getDiscountApplied = (totalSavedPrice, discounts) => {
    for (const discount of discounts) {
      if (totalSavedPrice >= discount.MinValue) {
        return discount.DiscountApplied;
      }
    }
    return null;
  };

  const discountApplied = getDiscountApplied(totalSavedPrice, discounts);

  const handlePayableAmountChange = (e) => {
    const enteredAmount =
      packageType == "Editable" ? e : parseFloat(e.target.value);
    if (
      !isNaN(enteredAmount) &&
      enteredAmount !== 0 &&
      totalRegularPrice !== 0
    ) {
      const discountPercentage = Math.round(
        ((totalRegularPrice - enteredAmount) / totalRegularPrice) * 100
      );
      setPayableAmount(enteredAmount);
      setDiscount(discountPercentage);
    } else {
      setPayableAmount("");
      setDiscount("");
    }
  };
  useEffect(() => {
    if (totalSavedPrice > 0 && packageType == "Editable") {
      handlePayableAmountChange(totalSavedPrice);
    }
  }, [totalSavedPrice]);


  console.log("selectedServices", selectedServices);

  // Function to check if all variants in package are active - accepts optional freshData param
  const checkAllVariantsActive = (freshData = null) => {
    const dataToUse = freshData || combineData;
    const inactiveServices = [];

    // Check main services
    selectedServices.forEach((serviceItem) => {
      if (!serviceItem.service || !serviceItem.variant) return;

      const serviceId = serviceItem.service;
      const variantId = serviceItem.variant;

      // ALWAYS try fresh data first
      let service = dataToUse?.newServiceId?.find(
        (s) => s._id === serviceId
      );

      // Fallback to package's populated data if service not found in combineData
      // (Inactive services are NOT returned by CombineApis, so we need this fallback)
      if (!service && item?.serviceId) {
        const originalServiceItem = item.serviceId.find(s => (s.service?._id || s.service) === serviceId);
        if (originalServiceItem?.service && typeof originalServiceItem.service === 'object') {
          service = originalServiceItem.service;
        }
      }

      if (service) {
        // ALWAYS look for variant in fresh/current service data first
        let variant = service.ServiceVarients?.find(
          (v) => v._id === variantId
        );

        // Fallback to package's populated variant data if not found
        if (!variant && item?.serviceId) {
          const originalServiceItem = item.serviceId.find(s => (s.service?._id || s.service) === serviceId);
          if (originalServiceItem?.service?.ServiceVarients) {
            variant = originalServiceItem.service.ServiceVarients.find(v => v._id === variantId);
          }
        }

        if (variant) {
          const variantStatus =
            variant.VarientDiscription?.[0]?.ServiceStatus;
          const isActive =
            variantStatus === true ||
            variantStatus === 1 ||
            variantStatus === "1";

          if (!isActive) {
            inactiveServices.push({
              serviceId: service._id,
              serviceName: service.ServiceName,
              variantId: variant._id || variantId,
              variantType: variant.ServiceType?.Name || 'Unknown',
              variantStatus: isActive ? "Active" : "Inactive",
              isActive: false,
            });
          }
        } else {
          console.warn('Variant not found for service:', service.ServiceName, 'variantId:', variantId);
        }
      }
    });

    // Check addon services
    if (packageType !== "Normal" && selectedAddons) {
      selectedAddons.forEach((addonItem) => {
        if (!addonItem.service || !addonItem.variant) return;

        const serviceId = addonItem.service;
        const variantId = addonItem.variant;

        // ALWAYS try fresh data first
        let service = dataToUse?.newServiceId?.find(
          (s) => s._id === serviceId
        );

        // Fallback to package's populated data if service not found in combineData
        // (Inactive services are NOT returned by CombineApis, so we need this fallback)
        if (!service && item?.AddonService) {
          const originalAddonItem = item.AddonService.find(s => (s.service?._id || s.service) === serviceId);
          if (originalAddonItem?.service && typeof originalAddonItem.service === 'object') {
            service = originalAddonItem.service;
          }
        }

        if (service) {
          // ALWAYS look for variant in fresh/current service data first
          let variant = service.ServiceVarients?.find(
            (v) => v._id === variantId
          );

          // Fallback to package's populated variant data if not found
          if (!variant && item?.AddonService) {
            const originalAddonItem = item.AddonService.find(s => (s.service?._id || s.service) === serviceId);
            if (originalAddonItem?.service?.ServiceVarients) {
              variant = originalAddonItem.service.ServiceVarients.find(v => v._id === variantId);
            }
          }

          if (variant) {
            const variantStatus =
              variant.VarientDiscription?.[0]?.ServiceStatus;
            const isActive =
              variantStatus === true ||
              variantStatus === 1 ||
              variantStatus === "1";

            if (!isActive) {
              inactiveServices.push({
                serviceId: service._id,
                serviceName: service.ServiceName,
                variantId: variant._id || variantId,
                variantType: variant.ServiceType?.Name || 'Unknown',
                variantStatus: isActive ? "Active" : "Inactive",
                isActive: false,
              });
            }
          } else {
            console.warn('Addon variant not found for service:', service.ServiceName, 'variantId:', variantId);
          }
        }
      });
    }

    return inactiveServices;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Check if trying to activate package
      if (ServiceStatus === "1" || ServiceStatus === 1) {
        // Refresh combineData to get latest service/variant status
        let freshCombineData = combineData;
        try {
          const response = await privateRequest.get(`Service/CombineApis`);
          freshCombineData = response?.data?.data;
          setCombineData(freshCombineData);
        } catch (refreshError) {
          console.error("Error refreshing combine data:", refreshError);
          // Use existing combineData if refresh fails
        }

        const inactiveServices = checkAllVariantsActive(freshCombineData);

        if (inactiveServices.length > 0) {
          // Build services table for popup
          const servicesTable = inactiveServices
            .map((service) => {
              return `
              <tr>
                <td style="padding:10px 14px; font-size:13px;">
                  <strong>${service.serviceName}</strong>
                  <br />
                  <small style="color:#6c757d; font-size:11px;">
                    Variant: ${service.variantType || "N/A"}
                  </small>
                </td>
                <td style="text-align:center;">
                  <span style="
                    padding:4px 10px;
                    font-size:11px;
                    border-radius:12px;
                    color:#fff;
                    background:#dc3545;
                  ">
                    Inactive
                  </span>
                </td>
                <td style="text-align:center;">
                  <button
                    style="
                      font-size:11px;
                      padding:4px 10px;
                      border-radius:4px;
                      border:none;
                      background:#0d6efd;
                      color:#fff;
                      cursor:pointer;
                    "
                    onclick="editService('${service.serviceId}')">
                    ✏️ Edit
                  </button>
                </td>
              </tr>
              `;
            })
            .join("");

          // Modal HTML (same style as EditService.js)
          const tableHTML = `
            <div style="text-align:center; margin-bottom:12px;">
              <div style="
                width:72px;
                height:72px;
                border-radius:50%;
                border:4px solid #f0ad4e;
                display:inline-flex;
                align-items:center;
                justify-content:center;
                font-size:34px;
                color:#f0ad4e;
                font-weight:700;
              ">!</div>
            </div>

            <!-- TITLE -->
            <h3 style="text-align:center; font-weight:600; margin-bottom:14px;">
              Inactive Service Variants Found
            </h3>

            <!-- WARNING BAR -->
            <div style="
              background:#fff3cd;
              border:1px solid #ffeeba;
              color:#856404;
              padding:10px 16px;
              font-size:13px;
              border-radius:6px;
              margin-bottom:14px;
              text-align:center;
            ">
              ⚠️ Package cannot be activated because some service variants are inactive.
              Please activate all service variants first.
            </div>

            <!-- TABLE CARD -->
            <div style="
              border:1px solid #dee2e6;
              border-radius:6px;
              overflow:hidden;
              background:#fff;
            ">
              <table style="width:100%; border-collapse:collapse;">
                <thead style="background:#343a40; color:#fff;">
                  <tr style="height:36px; background:#343a40; color:#fff;">
                    <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:left;">
                      🔧 Service Details
                    </th>

                    <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                      ℹ️ Status
                    </th>

                    <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                      ✏️ Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  ${servicesTable}
                </tbody>
              </table>
            </div>

            <!-- FOOTER NOTE -->
            <div style="
              margin-top:10px;
              font-size:12px;
              color:#6c757d;
              text-align:center;
            ">
              ℹ️ Click "Edit" to navigate to the service edit page and activate the variant.
            </div>
          `;

          Swal.fire({
            icon: undefined,
            html: tableHTML,
            width: 760,
            confirmButtonText: "OK",
            allowOutsideClick: false,
            customClass: {
              confirmButton: 'swal-btn-sm',
            },
            didOpen: () => {
              // Add style for button
              const style = document.createElement('style');
              style.textContent = `
                .swal-btn-sm {
                  font-size: 12px !important;
                  padding: 6px 14px !important;
                  border-radius: 4px !important;
                  min-height: auto !important;
                }
              `;
              document.head.appendChild(style);

              window.editService = (serviceId) => {
                Swal.close();
                // Find the service object to pass to edit page
                let service = combineData?.newServiceId?.find(
                  (s) => s._id === serviceId
                );

                // Fallback: If not found in combineData (inactive service), try to find in package's item data
                if (!service && item?.serviceId) {
                  const serviceItem = item.serviceId.find(s => (s.service?._id || s.service) === serviceId);
                  if (serviceItem?.service && typeof serviceItem.service === 'object') {
                    service = serviceItem.service;
                  }
                }

                // Fallback: Try addon services as well
                if (!service && item?.AddonService) {
                  const addonItem = item.AddonService.find(s => (s.service?._id || s.service) === serviceId);
                  if (addonItem?.service && typeof addonItem.service === 'object') {
                    service = addonItem.service;
                  }
                }

                if (service) {
                  // Store service data in sessionStorage for navigation
                  sessionStorage.setItem('serviceEditData', JSON.stringify(service));
                  window.open(`/service`, "_blank");
                } else {
                  window.open(`/service`, "_blank");
                }
              };
            },
          });

          return; // ⛔ BLOCK — don't update package
        }
      }

      const invalidVariant = selectedServices.some((item) => !item.variant);
      if (invalidVariant) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Please select a variant in all services.",
        });
        return;
      }

      if (packageType != "Normal") {
        const invalidVariant = selectedAddons.some((item) => !item.variant);

        if (invalidVariant) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Please select a variant in all services.",
          });
          return;
        }
      }

      const formData = new FormData();
      formData.append("packageTitle", Name);
      formData.append("PcatId", selectedParentCategory?.value);
      formData.append("discription", discription);
      formData.append("Status", ServiceStatus);
      formData.append("packageImage", selectedFile);
      formData.append("packageType", packageType);
      formData.append("RPrice", totalRegularPrice);
      formData.append("IsDiscription", isDiscription);
      formData.append("SPrice", totalSalePrice);
      formData.append(
        "payble",
        packageType == "Editable" ? totalSavedPrice : payableAmount
      );
      formData.append("discount", discount);
      formData.append("PCgroup", selectedGroup);

      // Debug: Log all form data being sent
      console.log('EditPackage - Form data being sent:', {
        packageTitle: Name,
        PcatId: selectedParentCategory?.value,
        discription: discription,
        Status: ServiceStatus,
        packageImage: selectedFile,
        packageType: packageType,
        RPrice: totalRegularPrice,
        IsDiscription: isDiscription,
        SPrice: totalSalePrice,
        payble: packageType == "Editable" ? totalSavedPrice : payableAmount,
        discount: discount,
        PCgroup: selectedGroup,
        selectedChildCategories: selectedChildCategories,
        selectedServiceGroups: selectedServiceGroups,
        selectedServices: selectedServices,
        selectedAddons: selectedAddons
      });

      selectedChildCategories.forEach((categoryId) => {
        // Ensure we have a valid value before appending
        if (categoryId && categoryId !== 'undefined') {
          formData.append("ChildId[]", categoryId);
        } else {
          console.log('EditPackage - Filtered out invalid child category:', categoryId);
        }
      });

      selectedServiceGroups.forEach((groupId) => {
        // Ensure we have a valid value before appending
        if (groupId && groupId.value && groupId.value !== 'undefined') {
          formData.append("ServiceGroups[]", groupId.value);
        } else {
          console.log('EditPackage - Filtered out invalid service group:', groupId);
        }
      });

      selectedServices.forEach((serviceId, index) => {
        // Ensure we have valid values before appending
        if (serviceId && serviceId.service && serviceId.service !== 'undefined') {
          formData.append(`serviceId[${index}][service]`, serviceId.service);
          formData.append(`serviceId[${index}][variant]`, serviceId.variant || '');
        } else {
          console.log('EditPackage - Filtered out invalid service:', serviceId);
        }
      });

      selectedAddons &&
        packageType != "Normal" &&
        selectedAddons.forEach((addonServiceId, index) => {
          // Ensure we have valid values before appending
          if (addonServiceId && addonServiceId.service && addonServiceId.service !== 'undefined') {
            formData.append(
              `AddonService[${index}][service]`,
              addonServiceId.service
            );
            formData.append(
              `AddonService[${index}][variant]`,
              addonServiceId.variant || ''
            );
          } else {
            console.log('EditPackage - Filtered out invalid addon service:', addonServiceId);
          }
        });

      // Get package ID from multiple sources with fallback
      const packageId = state?._id || item?._id || packageIdFromUrl || searchParams.get('packageId');

      console.log('EditPackage - Package ID sources:', {
        stateId: state?._id,
        itemId: item?._id,
        packageIdFromUrl: packageIdFromUrl,
        urlPackageId: searchParams.get('packageId'),
        finalPackageId: packageId
      });

      if (!packageId) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Package ID not found. Please try again.",
        });
        return;
      }

      // Validate required fields before making API call
      if (!Name) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Package title is required.",
        });
        return;
      }

      if (!selectedParentCategory?.value) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Parent category is required.",
        });
        return;
      }

      if (!selectedChildCategories || selectedChildCategories.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "At least one child category is required.",
        });
        return;
      }

      if (!selectedServiceGroups || selectedServiceGroups.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "At least one service group is required.",
        });
        return;
      }

      if (!selectedServices || selectedServices.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "At least one service is required.",
        });
        return;
      }

      const response = await privateRequest.put(
        `Package/UpdatePackage/${packageId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Service created successfully:", response.data);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Data added successfully!",
      });
      navigate("/package");
    } catch (error) {
      console.error("Error updating package:", error);
      console.error("Error response:", error.response);
      console.error("Error response data:", error.response?.data);

      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.message || "An error occurred while updating the package",
      });
    }
  };

  console.log("selectedServices", selectedServices);
  console.log("serviceOptions", serviceOptions);
  const selectedServiceIds = (selectedServices || []).map(
    (service) => service.service
  );
  const selectedAddonids = (selectedAddons || []).map(
    (service) => service.service
  );
  console.log("selectedServiceIds", selectedServiceIds);

  // Step 2: Filter out the selected services from the service options
  let a = [...selectedServiceIds, ...selectedAddonids];

  const filteredServiceOptions = serviceOptions?.filter(
    (service) => !a.includes(service._id)
  );

  console.log("filteredServiceOptions", filteredServiceOptions);

  return (
    <>
      <DebugDataDisplay />
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Edit Package</span>
                    </p>
                    <Link
                      to="/package/"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>All Packages
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Package Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Package Name"
                                value={Name}
                                onChange={(e) => setName(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Parent Category</label>

                              <Select
                                isClearable
                                value={selectedParentCategory}
                                onChange={handleParentCategoryChange}
                                options={
                                  combineData?.parentCategories?.map(
                                    (category) => ({
                                      value: category._id,
                                      label: category.PCName,
                                    })
                                  ) || []
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Child Category</label>
                              <Select
                                isMulti
                                value={childCategoryOptions.filter((option) =>
                                  selectedChildCategories.includes(option.value)
                                )}
                                onChange={handleChildCategoryChange}
                                options={childCategoryOptions}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Service Group</label>

                              <Select
                                isMulti
                                value={selectedServiceGroups}
                                label="Select Service Groups"
                                options={ServiceGroupOptions}
                                onChange={(selectedOptions) => {
                                  const selectedValues = selectedOptions.map(
                                    (option) => ({
                                      label: option.label,
                                      value: option.value,
                                    })
                                  );
                                  setSelectedServiceGroups(selectedValues);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Image</label>
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={handleFileInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Package Type</label>
                              <select
                                className="form-control"
                                value={packageType}
                                onChange={(e) => setPackageType(e.target.value)}
                                disabled={true}
                              >
                                <option value="">Select</option>
                                <option value="Normal">Normal</option>
                                <option value="Customize">Customize</option>
                                <option value="Editable">Editable</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Status</label>
                              <select
                                className="form-control"
                                value={ServiceStatus}
                                onChange={(e) =>
                                  setServiceStatus(e.target.value)
                                }
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>
                          {imagePreview && (
                            <div className="col-lg-4">
                              <img
                                width="80"
                                height="50"
                                src={imagePreview}
                                alt="Preview"
                                style={{ maxWidth: "100%" }}
                              />
                            </div>
                          )}

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>
                                Parent Catagory Group For Services List
                              </label>
                              <select
                                className="form-control"
                                value={selectedGroup}
                                onChange={handleGroupChange}
                              >
                                <option>Select</option>
                                {combineData?.ParentGroup?.map(
                                  (item, index) => {
                                    return (
                                      <option key={item?._id} value={item?._id}>
                                        {item?.PCGName}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                          </div>
                          <div className="custom-control custom-control-inline custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="ckb1"
                              name="spCommentShow"
                              checked={isDiscription == true ? true : false}
                              value="1"
                              onChange={(e) => {
                                setisDiscription(!isDiscription);
                              }}
                            />{" "}
                            <label
                              className="custom-control-label"
                              htmlFor="ckb1"
                            >
                              Is Description
                            </label>
                          </div>
                        </div>
                        <hr />

                        <div
                          style={{
                            marginBottom: 40,
                          }}
                          className="col-lg-4 "
                        >
                          <tbody></tbody>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-sm">
                              <thead className="bg-primary text-white">
                                <tr>
                                  <td colSpan={3}>Services</td>
                                </tr>
                              </thead>
                              {combineData?.newServiceId?.length > 0 && (
                                <tbody>
                                  <tr key={0}>
                                    <td style={{ width: "10%" }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-icon"
                                        onClick={handleAddService}
                                      >
                                        <i className="fa fa-plus"></i>
                                      </button>
                                    </td>
                                  </tr>

                                  {selectedServices?.map((service, index) => {
                                    let a = combineData?.newServiceId?.find(
                                      (item) => item?._id == service?.service
                                    );

                                    // Fallback: If not found in combineData, try to find in initial item data
                                    if (!a && item?.serviceId) {
                                      const originalServiceItem = item.serviceId.find(s => (s.service?._id || s.service) === service?.service);
                                      if (originalServiceItem?.service && typeof originalServiceItem.service === 'object') {
                                        a = originalServiceItem.service;
                                      }
                                    }

                                    let values = {
                                      value: service.service,
                                      label:
                                        a?.ServiceName +
                                        " - " +
                                        a?.ChildCatIDs?.CCName || "",
                                    };

                                    let VariantOptions = getVariantsForService(
                                      selectedServices &&
                                      selectedServices[index]?.service
                                    );

                                    // Check if the currently selected variant exists in the options
                                    const selectedVariantId = selectedServices?.[index]?.variant;
                                    let selectedVariantInOptions = VariantOptions?.find(v => v._id === selectedVariantId);

                                    // If selected variant is not in options (inactive), find it from item data and add it
                                    if (selectedVariantId && !selectedVariantInOptions && item?.serviceId) {
                                      const originalServiceItem = item.serviceId.find(s => (s.service?._id || s.service) === service?.service);
                                      if (originalServiceItem?.service?.ServiceVarients) {
                                        const inactiveVariant = originalServiceItem.service.ServiceVarients.find(v => v._id === selectedVariantId);
                                        if (inactiveVariant) {
                                          // Add the inactive variant to the options for display
                                          VariantOptions = [...(VariantOptions || []), inactiveVariant];
                                        }
                                      }
                                    }

                                    console.log("a", a);

                                    let valued =
                                      selectedServices &&
                                      selectedServices[index]?.variant;
                                    console.log("valued", valued);
                                    const invalidVariant =
                                      selectedServices.some(
                                        (item) => !item.variant
                                      );

                                    return (
                                      <tr key={index}>
                                        <td style={{ width: "50%" }}>
                                          <Select
                                            isClearable
                                            onChange={(e) =>
                                              handleServiceChange(
                                                index,
                                                e.value
                                              )
                                            }
                                            // options={
                                            //   filteredServiceOptions?.map(
                                            //     (option) => ({
                                            //       value: option._id,
                                            //       label:
                                            //         option.ServiceName +
                                            //         " - " +
                                            //         option?.ChildCatIDs?.CCName,
                                            //     })
                                            //   ) || []
                                            // }

                                            options={
                                              packageType === "Customize"
                                                ? serviceOptions?.map(
                                                  (option) => ({
                                                    value: option._id,
                                                    label: `${option.ServiceName
                                                      } - ${option?.ChildCatIDs
                                                        ?.CCName || ""
                                                      }`,
                                                  })
                                                ) || []
                                                : filteredServiceOptions?.map(
                                                  (option) => ({
                                                    value: option._id,
                                                    label: `${option.ServiceName
                                                      } - ${option?.ChildCatIDs
                                                        ?.CCName || ""
                                                      }`,
                                                  })
                                                ) || [] // Fallback to an empty array if filteredServiceOptions is undefined
                                            }
                                            value={values}
                                          />
                                        </td>
                                        <td style={{ width: "50%" }}>
                                          <select
                                            value={service.variant}
                                            onChange={(e) => {
                                              let variantPrice =
                                                getVariantsForService(
                                                  selectedServices[index]
                                                    ?.service
                                                ).find(
                                                  (id) =>
                                                    id._id == e.target.value
                                                );

                                              let regularPrice =
                                                variantPrice
                                                  ?.VarientDiscription[0]
                                                  ?.regularPrice;

                                              let salePrice =
                                                variantPrice
                                                  ?.VarientDiscription[0]
                                                  ?.salePrice;

                                              let a = {
                                                regularPrice,
                                                salePrice,
                                                id: e.target.value,
                                              };
                                              handleVariantChange(index, a);
                                            }}
                                            className="form-control"
                                          >
                                            <option value={""}>
                                              Select Variant
                                            </option>
                                            {VariantOptions?.map((variant) => (
                                              <option
                                                key={variant._id}
                                                value={variant._id}
                                              >
                                                {variant?.ServiceType?.Name}
                                              </option>
                                            ))}
                                          </select>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-icon"
                                            onClick={() => {
                                              const invalidVariant =
                                                selectedServices.some(
                                                  (item) => !item.variant
                                                );
                                              if (invalidVariant) {
                                                Swal.fire({
                                                  icon: "error",
                                                  title: "Error!",
                                                  text: "Please select a variant in this service before its remove",
                                                });
                                              } else {
                                                handleRemoveService(
                                                  service?.variant
                                                );
                                              }
                                            }}
                                          >
                                            <i className="fa fa-minus"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              )}
                            </table>
                          </div>

                          {packageType != "Normal" && (
                            <div className="col-lg-12">
                              <table className="table table-sm">
                                <thead className="bg-primary text-white">
                                  <tr>
                                    <td colSpan={3}>Add on Services</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <td style={{ width: "10%" }}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-icon"
                                      onClick={handleAddAddonService}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </button>
                                  </td>

                                  {selectedAddons?.map((service, index) => {
                                    let a = combineData?.newServiceId?.find(
                                      (item) => item?._id == service?.service
                                    );

                                    // Fallback: If not found in combineData, try to find in initial item data
                                    if (!a && item?.AddonService) {
                                      const originalAddonItem = item.AddonService.find(s => (s.service?._id || s.service) === service?.service);
                                      if (originalAddonItem?.service && typeof originalAddonItem.service === 'object') {
                                        a = originalAddonItem.service;
                                      }
                                    }

                                    let values = {
                                      value: service.service || 0,
                                      label:
                                        a?.ServiceName +
                                        " - " +
                                        a?.ChildCatIDs?.CCName,
                                    };
                                    let sample = {
                                      label: "Select Service",
                                      value: "",
                                    };
                                    return (
                                      <tr key={index}>
                                        <td style={{ width: "50%" }}>
                                          {/* <select
                                            value={service?.service}
                                            onChange={(e) =>
                                              handleAddOnServiceChange(
                                                index,
                                                e.target.value
                                              )
                                            }
                                            options={filteredServiceOptions?.map(
                                              (option) => ({
                                                value: option._id,
                                                label:
                                                  option.ServiceName +
                                                  " - " +
                                                  option?.ChildCatIDs?.CCName,
                                              })
                                            )}
                                            className="form-control"
                                          >
                                            <option>Select Service</option>
                                            {filteredServiceOptions?.map(
                                              (option, index) => {
                                                return (
                                                  <option
                                                    key={option?._id}
                                                    value={option._id}
                                                  >
                                                    {option.ServiceName +
                                                      " - " +
                                                      option?.ChildCatIDs
                                                        ?.CCName}
                                                  </option>
                                                );
                                              }
                                            )}
                                          </select> */}
                                          <Select
                                            isClearable
                                            value={
                                              values.label ==
                                                "undefined - undefined"
                                                ? sample
                                                : values
                                            }
                                            onChange={(e) =>
                                              handleAddOnServiceChange(
                                                index,
                                                e.value
                                              )
                                            }
                                            // options={filteredServiceOptions?.map(
                                            //   (option) => ({
                                            //     value: option._id,
                                            //     label:
                                            //       option.ServiceName +
                                            //       " - " +
                                            //       option?.ChildCatIDs?.CCName,
                                            //   })
                                            // )}
                                            options={
                                              packageType === "Customize"
                                                ? serviceOptions?.map(
                                                  (option) => ({
                                                    value: option._id,
                                                    label: `${option.ServiceName
                                                      } - ${option?.ChildCatIDs
                                                        ?.CCName || ""
                                                      }`,
                                                  })
                                                ) || []
                                                : filteredServiceOptions?.map(
                                                  (option) => ({
                                                    value: option._id,
                                                    label: `${option.ServiceName
                                                      } - ${option?.ChildCatIDs
                                                        ?.CCName || ""
                                                      }`,
                                                  })
                                                ) || [] // Fallback to an empty array if filteredServiceOptions is undefined
                                            }
                                          />
                                        </td>
                                        <td style={{ width: "50%" }}>
                                          <select
                                            value={service.variant}
                                            onChange={(e) =>
                                              handleVariantAddOnChange(
                                                index,
                                                e.target.value
                                              )
                                            }
                                            className="form-control"
                                          // disabled={!service.service}
                                          >
                                            <option value={null}>
                                              Select Variant
                                            </option>

                                            {(() => {
                                              let addonVariantOptions = getVariantsForService(
                                                selectedAddons[index]?.service
                                              );

                                              // Check if the currently selected variant exists in the options
                                              const selectedAddonVariantId = selectedAddons?.[index]?.variant;
                                              const selectedAddonVariantInOptions = addonVariantOptions?.find(v => v._id === selectedAddonVariantId);

                                              // If selected variant is not in options (inactive), find it from item data and add it
                                              if (selectedAddonVariantId && !selectedAddonVariantInOptions && item?.AddonService) {
                                                const originalAddonItem = item.AddonService.find(s => (s.service?._id || s.service) === service?.service);
                                                if (originalAddonItem?.service?.ServiceVarients) {
                                                  const inactiveVariant = originalAddonItem.service.ServiceVarients.find(v => v._id === selectedAddonVariantId);
                                                  if (inactiveVariant) {
                                                    addonVariantOptions = [...(addonVariantOptions || []), inactiveVariant];
                                                  }
                                                }
                                              }

                                              return addonVariantOptions?.map((variant) => (
                                                <option
                                                  key={variant._id}
                                                  value={variant._id}
                                                >
                                                  {variant?.ServiceType?.Name}
                                                </option>
                                              ));
                                            })()}
                                          </select>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-icon"
                                            onClick={() =>
                                              handleRemoveAdonService(
                                                service?.variant
                                              )
                                            }
                                          >
                                            <i className="fa fa-minus"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>

                        <hr />
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Regular Price</label>
                              <input
                                readOnly
                                type="number"
                                className="form-control"
                                placeholder="Regular Price"
                                value={totalRegularPrice}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Sale Price</label>
                              <input
                                readOnly
                                type="number"
                                className="form-control"
                                placeholder="Sale Price"
                                value={totalSalePrice}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Payable Amount</label>
                              {/* <input
                                type="number"
                                className="form-control"
                                placeholder="Payable Amount"
                                value={payableAmount}
                                onChange={handlePayableAmountChange}
                              /> */}
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Payable Amount"
                                value={
                                  packageType == "Editable"
                                    ? totalSavedPrice
                                    : payableAmount
                                }
                                onChange={handlePayableAmountChange}
                                readOnly={
                                  packageType == "Editable" ? true : false
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Discount</label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Discount"
                                value={discount}
                                onChange={(e) => {
                                  let a = parseInt(e.target.value);
                                  setDiscount(a);
                                }}
                                readOnly={packageType !== "Editable"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>Discription</label>

                              <ReactQuill
                                className="h-100"
                                modules={{
                                  toolbar: [
                                    [{ header: [1, 2, false] }],
                                    [
                                      "bold",
                                      "italic",
                                      "underline",
                                      "strike",
                                      "blockquote",
                                    ],
                                    [
                                      { list: "ordered" },
                                      { list: "bullet" },
                                      { indent: "-1" },
                                      { indent: "+1" },
                                    ],
                                    ["link", "image"],
                                    ["clean"],
                                  ],
                                }}
                                theme="snow"
                                formats={[
                                  "header",
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                  "list",
                                  "bullet",
                                  "indent",
                                  "link",
                                  "image",
                                ]}
                                value={discription}
                                onChange={(e) => {
                                  setDiscription(e);
                                }}
                              />
                              {/* <Editor
                                id="allDiscription"
                                onChange={handleChange}
                                apiKey="ndr3qx00ekfzcl7za2m8nsmj6w05hnc3dtaouikvf4t5wd6l"
                                init={{
                                  plugins:
                                    "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss markdown",
                                  toolbar:
                                    "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
                                  tinycomments_mode: "embedded",
                                  tinycomments_author: "Author name",
                                  mergetags_list: [
                                    {
                                      value: "First.Name",
                                      title: "First Name",
                                    },
                                    {
                                      value: "Email",
                                      title: "Email",
                                    },
                                  ],
                                  ai_request: (request, respondWith) =>
                                    respondWith.string(() =>
                                      Promise.reject(
                                        "See docs to implement AI Assistant"
                                      )
                                    ),
                                }}
                                initialValue="Welcome to TinyMCE!"
                              /> */}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12">
                            <button type="submit" className="btn btn-primary ">
                              Update Package
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditPackage;
